import { gsap } from 'gsap'

const filterEl = document.querySelector('.js-filter')

class Filter {
	constructor() {
		this.filter = filterEl
		this.checkbox = this.filter.querySelectorAll('.filter-panel-catalog__item')
		this.checkbox.forEach(item => {
			item.querySelector('input').addEventListener('change', () => {
				this.submitForm()
			})
		})
	}

	submitForm() {
		this.filter.submit()
	}
}

class FilterSort {
	constructor(filter) {
		this.filterClass = filter
		this.filter = this.filterClass.filter
		this.sort = this.filter.querySelector('.sort-panel-catalog')
		this.sortInput = this.sort.querySelector('input')
		this.sortCurrent = this.sort.querySelector('.sort-panel-catalog__current')
		this.sortDropdown = this.sort.querySelector('.sort-panel-catalog__dropdown')
		this.timeline = gsap.timeline({ paused: true })
		this.toggleVisibleSortDropdown()
		this.sortCurrent.addEventListener('click', () => {
			if (this.getVisibleDropdown() === 'block') {
				this.timeline.reverse()
			} else {
				this.timeline.play()
			}
		})

		document.addEventListener("click", (e) => {
			if (this.getTargetDocument(e)) {
				this.timeline.reverse()
			}
		})

		this.setValueSort()
	}

	toggleVisibleSortDropdown() {
		this.timeline
			.to(this.sortDropdown, {
				duration: 0.2,
				display: 'block',
				opacity: 1
			})
	}

	setValueSort() {
		this.sortDropdown.querySelectorAll('.sort-panel-catalog__item').forEach(item => {
			item.addEventListener('click', () => {
				const val = item.getAttribute('data-value')
				const text = item.textContent
				this.sortInput.value = val
				this.sortCurrent.querySelector('span').innerText = text
				this.timeline.reverse()
				this.filterClass.submitForm()
			})
		})
	}

	getVisibleDropdown() {
		return window.getComputedStyle(this.sortDropdown).display
	}

	getTargetDocument(e) {
		const target = e.target
		const isDropdown = target === this.sortDropdown || this.sortDropdown.contains(target)
		const isCurrent = target === this.sortCurrent

		return !isDropdown && !isCurrent && this.getVisibleDropdown() === 'block'
	}
}

if (filterEl) {
	const filter = new Filter()
	const filterSort = new FilterSort(filter)
}

